import { Controller } from "@hotwired/stimulus"

// Refonte cards hero (22/05/2026) — Toggle expand sur card campagne pour dérouler
// session associée + criteria + 5 derniers contacts qualifiés.
export default class extends Controller {
  static targets = ["details", "labelClosed", "labelOpen"]

  toggle(event) {
    event.preventDefault()
    const isOpen = !this.detailsTarget.hidden ? false : true
    this.detailsTarget.hidden = !isOpen
    if (this.hasLabelClosedTarget) this.labelClosedTarget.hidden = isOpen
    if (this.hasLabelOpenTarget) this.labelOpenTarget.hidden = !isOpen
    const btn = event.currentTarget
    btn.setAttribute("aria-expanded", isOpen ? "true" : "false")
    this.element.classList.toggle("is-expanded", isOpen)
  }
}
